'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var react = require('@chakra-ui/react');
react.ModalHeader.id = 'ModalHeader';
Object.defineProperty(exports, 'ModalHeader', {
  enumerable: true,
  get: function () {
    return react.ModalHeader;
  }
});